import React, { useState } from 'react'

import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  Slider,
  Stack,
  TableContainer,
} from '@mui/material'
import { listFromCodes } from '../../../Functions/ListItemGenerator'
import { DataGridPro } from '@mui/x-data-grid-pro'
import { useHoldingContext } from '../../../Contexts/CurrentHolding'
import { useUserContext } from '../../../Contexts/UserConfig'
import { useGetBPLitterReport } from '../../../APIs/Hooks/ReportServiceHooks'
import { appBar } from '../../../garvan-react/Constants/StyleConstants'
import PageSection from '../../../Constants&Theme/PageSection'
import { bpLitterReportCols } from './BPLitterReportCols'
import { stackGap } from '../../../Constants&Theme/Spacing'
import { reportDGProps } from '../ReportProps'

function BPLitterReport() {
  const { currentHolding } = useHoldingContext()
  const { loginConfig, loadingConfig } = useUserContext()
  const [holdingID, setHoldingID] = useState(currentHolding.value)
  const [litterSeq, setlitterSeq] = useState(6)
  const reportQuery = useGetBPLitterReport(holdingID, litterSeq)
  const holdings = listFromCodes(
    loginConfig,
    'KV-Holdings',
    loadingConfig,
    currentHolding.value,
  )

  return (
    <Box
      sx={{
        maxWidth: 'xl',
        width: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <PageSection title={'Breeding Pair Litters Report'}>
        <Stack
          direction={'row'}
          gap={stackGap.col}
          mb={2}
          width={1}
        >
          <FormControl
            fullWidth
            sx={{ flex: 2 }}
          >
            <InputLabel>Select Holding</InputLabel>
            <Select
              inputProps={{ 'aria-label': 'SelectHolding' }}
              label="Select Holding"
              value={holdingID}
              onChange={(e) => setHoldingID(e.target.value as number)}
            >
              {holdings}
            </Select>
          </FormControl>
          <Box
            sx={{
              flex: 1,
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Slider
              value={litterSeq}
              step={1}
              min={5}
              max={8}
              valueLabelDisplay="on"
              onChange={(e, val) => setlitterSeq(val as number)}
            />
            <FormHelperText>{'Litter Qty (is > or =)'}</FormHelperText>
          </Box>
        </Stack>
      </PageSection>
      <TableContainer
        sx={{ height: `calc(100vh - ${appBar}px - 300px)`, width: 1 }}
      >
        <DataGridPro
          {...reportDGProps}
          getRowId={(row) => `${row.ShortLineName}${row.BPID}`}
          rows={reportQuery.data ?? []}
          columns={bpLitterReportCols}
          loading={reportQuery.isFetching}
        />
      </TableContainer>
    </Box>
  )
}

export default BPLitterReport
